/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-shadow */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-expressions */

import React, { useMemo, useState } from 'react';
import { useTable, useSortBy, usePagination, useRowSelect } from 'react-table';
import { useParams } from 'react-router-dom';
// import { ShortBothIcon, ShortDownIcon, ShortUpIcon } from '../icons/icons';
import Checkbox from '../custom-checkbox/custom-checkbox';
import {
  // NewTrashIcon,
  RedCircleMinusIcon,
  ShortBothIcon,
  ShortDownIcon,
  ShortUpIcon,
} from '../icons/icons';
import './table.scss';
import { giveProfile } from '../global-notification/notification-list';
import IconButton from '../icon-button/icon-button';
import Tooltip from '../tooltip/tooltip';
import { Refresh } from '../icons/comments-icon';

const IndeterminateCheckbox = React.forwardRef(
  (
    {
      indeterminate,
      // isChecked,
      ...rest
    },
    ref
  ) => {
    const defaultRef = React.useRef();
    const resolvedRef = ref || defaultRef;
    // const [value, setValue] = useState('')

    React.useEffect(() => {
      resolvedRef.current.indeterminate = indeterminate;
    }, [resolvedRef, indeterminate]);

    return (
      <>
        <Checkbox
          ref={resolvedRef}
          {...rest}
          title=""
          // checked={isChecked}
        />
        <input
          type="checkbox"
          ref={resolvedRef}
          style={{ display: 'none' }}
          checked
        />
      </>
    );
  }
);

function DefaultCell({ value }) {
  return <span>{value ?? ''}</span>;
}

function CustomTable({
  columns,
  data,
  poIdSelected,
  poItemCodeArray,
  BookingIdSelected,
  getChildData,
  pageSize,
  isCheckBoxRequired,
  setSortColumnHeader,
  setSort,
  handleSortArrow,
  handleColumnHeader,
  lineItemIdSelected,
  className,
  isBulk = false,
  selectedOrderIds,
  excludeIds,
  deleteMessage,
  isCustoms,
  setAllItemsSelected,
}) {
  const { relation } = useParams();
  const [BookingIdSelectedArray, setBookingIdSelectedArray] = useState([]);
  const [poIdSelectedArray, setPoIdSelectedArray] = useState([]);
  const [lineItemIdArray, setLineItemIdArray] = useState([]);
  const [itemCodeArray, setItemCodeArray] = useState([]);
  const perPage = pageSize && pageSize > 0 ? pageSize : 50;
  // headerGroup is an array for theader - hedaerGroup props

  let currentIndex = 0;
  const result = data?.reduce((acc, row) => {
    const index = currentIndex++;
    if (selectedOrderIds?.includes(row?.poId || row?._id || row?.shipmentId)) {
      acc[index] = true;
    } else {
      acc[index] = false;
    }
    if (excludeIds?.includes(row?.poId)) {
      acc[index] = false;
    }
    return acc;
  }, {});

  const enhancedColumns = useMemo(() => {
    return columns?.map((col) => {
      if (!col?.Cell && col?.accessor) {
        return {
          ...col,
          Cell: ({ row }) => {
            const value = row.original?.[col.accessor];
            return <DefaultCell value={value} />;
          },
        };
      }
      return col;
    });
  }, [columns]);

  const { getTableProps, getTableBodyProps, headerGroups, prepareRow, rows } =
    useTable(
      {
        columns: enhancedColumns,
        data,
        initialState: {
          pageSize: perPage,
          selectedRowIds: result,
          // selectedRowIds: { 0: true, 1: true, 3: false },
        },
        setSortColumnHeader,
        setSort,
        handleSortArrow,
        handleColumnHeader,
      },
      useSortBy,
      usePagination,
      useRowSelect,
      (hooks) => {
        hooks?.visibleColumns?.push((columns) => [
          {
            id: 'anyThing',
            disableSortBy: true,
            Header: ({ toggleRowSelected, isAllPageRowsSelected, page }) => {
              if (setAllItemsSelected) {
                setAllItemsSelected(isAllPageRowsSelected);
              }
              const modifiedOnChange = (event) => {
                page.forEach((row) => {
                  !row.original.disabled &&
                    toggleRowSelected(row.id, event.currentTarget.checked);
                });
              };

              let selectableRowsInCurrentPage = 0;
              let selectedRowsInCurrentPage = 0;
              page.forEach((row) => {
                row.isSelected && selectedRowsInCurrentPage++;
                !row.original.disabled && selectableRowsInCurrentPage++;
              });

              const disabled = selectableRowsInCurrentPage === 0;
              const checked =
                (isAllPageRowsSelected ||
                  selectableRowsInCurrentPage === selectedRowsInCurrentPage) &&
                !disabled;

              return (
                isCheckBoxRequired !== false &&
                !isCustoms && (
                  <IndeterminateCheckbox
                    onChange={(e) => {
                      modifiedOnChange(e);
                      getChildData(page, e.target.checked);
                    }}
                    checked={checked}
                    disabled={disabled}
                  />
                )
              );
            },
            Cell: ({ toggleRowSelected, row }) => {
              return row?.original?.isDeleted ? (
                <Tooltip content={deleteMessage} direction="top">
                  <IconButton verient="reject" background="transparent">
                    <RedCircleMinusIcon />
                  </IconButton>
                </Tooltip>
              ) : (
                // <NewTrashIcon />
                isCheckBoxRequired !== false && (
                  <IndeterminateCheckbox
                    {...row.getToggleRowSelectedProps()}
                    disabled={row.original.disabled}
                    onChange={(event) => {
                      toggleRowSelected(row.id, event.currentTarget.checked);
                      getChildData(row.original, event.target.checked);
                      if (row.original.__typename === 'BookingListData') {
                        if (!row.isSelected === false) {
                          const removeBookingIdIndex =
                            BookingIdSelectedArray.indexOf(
                              row.original.BookingId
                            );
                          setBookingIdSelectedArray(
                            BookingIdSelectedArray.splice(
                              removeBookingIdIndex,
                              1
                            )
                          );
                          BookingIdSelected(BookingIdSelectedArray);
                        } else {
                          setBookingIdSelectedArray(
                            BookingIdSelectedArray?.push(row.original.BookingId)
                          );
                          BookingIdSelected(BookingIdSelectedArray);
                        }
                      }

                      // previous logic
                      // if (
                      //   row.original.__typename === 'LineListItem' &&
                      //   !isBulk
                      // ) {
                      //   if (!row.isSelected === false) {
                      //     const removeLineIdIndex = lineItemIdArray?.indexOf(
                      //       row.original._id
                      //     );
                      //     setLineItemIdArray(
                      //       lineItemIdArray?.splice(removeLineIdIndex, 1)
                      //     );
                      //     lineItemIdSelected(lineItemIdArray);
                      //     itemCodeArray?.splice(removeLineIdIndex, 1);
                      //     poItemCodeArray(itemCodeArray);
                      //   } else {
                      //     itemCodeArray?.push(row.original.itemCode);

                      //     setItemCodeArray(itemCodeArray);
                      //     poItemCodeArray(itemCodeArray);

                      //     setLineItemIdArray(
                      //       lineItemIdArray?.push(row.original._id)
                      //     );
                      //     lineItemIdSelected(lineItemIdArray);
                      //   }
                      // }

                      // updated logic
                      if (
                        row.original.__typename === 'LineListItem' &&
                        !isBulk
                      ) {
                        if (!row.isSelected === false) {
                          // REMOVE
                          const removeLineIdIndex = lineItemIdArray.indexOf(
                            row.original._id
                          );

                          if (removeLineIdIndex > -1) {
                            const updatedLineIds = [...lineItemIdArray];
                            updatedLineIds.splice(removeLineIdIndex, 1);
                            setLineItemIdArray(updatedLineIds);
                            lineItemIdSelected(updatedLineIds);

                            const updatedItemCodes = [...itemCodeArray];
                            updatedItemCodes.splice(removeLineIdIndex, 1);
                            setItemCodeArray(updatedItemCodes);
                            poItemCodeArray(updatedItemCodes);
                          }
                        } else {
                          // ADD
                          const updatedLineIds = [
                            ...lineItemIdArray,
                            row.original._id,
                          ];
                          setLineItemIdArray(updatedLineIds);
                          lineItemIdSelected(updatedLineIds);

                          const updatedItemCodes = [
                            ...itemCodeArray,
                            row.original.itemCode,
                          ];
                          setItemCodeArray(updatedItemCodes);
                          poItemCodeArray(updatedItemCodes);
                        }
                      }

                      if (
                        row.original.__typename === 'LineListItem' &&
                        isBulk
                      ) {
                        return;
                      }

                      if (row.original.__typename === 'POList') {
                        if (!row.isSelected === false) {
                          const removePoIdIndex = poIdSelectedArray.indexOf(
                            row.original.poId
                          );
                          setPoIdSelectedArray(
                            poIdSelectedArray.splice(removePoIdIndex, 1)
                          );
                          poIdSelected(poIdSelectedArray);
                          itemCodeArray?.splice(removePoIdIndex, 1);
                          // poItemCodeArray(itemCodeArray);
                        } else {
                          const tempItemCodeArray = [];
                          row.original.lineItems.map((e) =>
                            tempItemCodeArray?.push(e.itemCode)
                          );

                          setItemCodeArray(
                            itemCodeArray?.push(tempItemCodeArray)
                          );
                          // poItemCodeArray(itemCodeArray);
                          setPoIdSelectedArray(
                            poIdSelectedArray.push(row.original.poId)
                          );
                          poIdSelected(poIdSelectedArray);
                        }
                      }
                    }}
                  />
                )
              );
            },
          },
          ...columns,
        ]);
      }
    );

  const disableInTodo = rows?.some(
    (row) =>
      row?.isSelected &&
      row?.original?.currentStatus === 'New' &&
      !row.original.parent
  );

  return (
    <div className={`custom-table-container ${className}`}>
      <table {...getTableProps()}>
        <thead>
          {headerGroups?.map((headerGroup) => (
            <tr {...headerGroup?.getHeaderGroupProps()}>
              {headerGroup?.headers?.map((column) => (
                <th
                  style={{ width: column.setWidth }}
                  className={`${
                    column.render('Header') === 'Notification'
                      ? 'notification'
                      : column.render('Header') === 'Booking No.'
                      ? 'id'
                      : column.render('Header') === 'Booking Date'
                      ? 'date-time'
                      : column.render('Header') === 'Quantity'
                      ? 'center'
                      : column.render('Header') === 'Mode'
                      ? 'center'
                      : column.align !== undefined
                      ? column.align
                      : ''
                  }${column.className ? ` ${column.className}` : ''}${
                    handleColumnHeader === column?.id ? ' sort' : ''
                  }`}
                >
                  <span>
                    {column.render('Header')}
                    {column.enableSortBy ? (
                      <span>
                        {handleSortArrow === 0 && (
                          <button
                            type="button"
                            tabIndex="0"
                            onClick={() => {
                              setSort(1);
                              setSortColumnHeader(column?.id);
                            }}
                          >
                            <ShortBothIcon color="#999999" />
                          </button>
                        )}
                        {handleSortArrow === 1 && (
                          <button
                            type="button"
                            tabIndex="0"
                            onClick={() => {
                              setSort(-1);
                              setSortColumnHeader(column?.id);
                            }}
                          >
                            {handleColumnHeader === column?.id ? (
                              <ShortDownIcon color="#999999" />
                            ) : (
                              <ShortBothIcon color="#999999" />
                            )}
                          </button>
                        )}
                        {handleSortArrow === -1 && (
                          <button
                            type="button"
                            tabIndex="0"
                            onClick={() => {
                              setSortColumnHeader(column?.id);
                              setSort(1);
                            }}
                          >
                            {handleColumnHeader === column?.id ? (
                              <ShortUpIcon color="#999999" />
                            ) : (
                              <ShortBothIcon color="#999999" />
                            )}
                          </button>
                        )}
                        {handleColumnHeader === column?.id &&
                          column.refresh && (
                            <button
                              type="button"
                              tabIndex="0"
                              onClick={() => {
                                setSortColumnHeader('');
                                setSort(0);
                              }}
                            >
                              <Refresh size="0.764vw" color="#0088FA" />
                            </button>
                          )}
                      </span>
                    ) : null}
                  </span>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows?.map((row) => {
            prepareRow(row);
            return (
              <tr
                {...row?.getRowProps()}
                id={row.id}
                value={row?.getRowProps()}
                className={`${
                  // !row.parent &&
                  row.isSelected &&
                  (disableInTodo && giveProfile(relation) === 'supplier'
                    ? ![
                        'Rejected',
                        'Change Requested',
                        'Partially Accepted',
                      ].includes(row?.original?.currentStatus)
                    : true)
                    ? 'active'
                    : ''
                }${row.original.isDeleted ? ' disabled' : ''}`}
              >
                {row?.cells?.map((cell, index) => {
                  const { column } = cell;
                  return (
                    <td
                      {...cell?.getCellProps()}
                      className={`
                        ${
                          cell.render('Header') === 'Notification' &&
                          'notification'
                        }
                          ${cell.render('Header') === 'Shipper' && 'no-wrap'}
                          ${cell.render('Header') === 'Consignee' && 'no-wrap'}
                          ${cell.column.align}
                       ${cell.column.className}${
                        index === 0 && row?.original?.isDeleted
                          ? ' pl-5-5 enable-pointer enabled'
                          : ''
                      }${handleColumnHeader === column?.id ? ' sort' : ''}`}
                      style={{
                        opacity:
                          column.id !== 'anyThing' &&
                          column.id !== 'username' &&
                          disableInTodo &&
                          giveProfile(relation) === 'supplier' &&
                          [
                            'Rejected',
                            'Change Requested',
                            'Partially Accepted',
                          ].includes(row?.original?.currentStatus)
                            ? 0.5
                            : 1,
                        width: cell.column.setWidth,
                      }}
                    >
                      {cell?.render('Cell')}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default CustomTable;
